import React, { useEffect, useState } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { SweetAlertShow, LoadingDiv } from "../master/Master";
import { Link, useLocation } from "react-router-dom";
import { formatToDate } from "../master/FormatToDateTime";
import usePrivateLink from "../config/usePrivateLink";
import { studentDetails } from "../../api/Student";
import { imgBaseUrl } from "../../api/api";
import CourseNFees from "./tabs/v1/CourseNFees";
import FeeTransactions from "./tabs/FeeTransactions";
import MarkReports from "./tabs/MarkReports";
import AttendanceCalendar from "./tabs/Attendance";
import StudentAdmissionForm from "./tabs/StudentAdmissionForm";
import StudentDemoForm from "./tabs/StudentDemoForm";
import Master from "./Master";

export default function StudentDetails() {
  const hasAccess = usePrivateLink();
  const [loading, setLoading] = useState("");
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const id = params.get("id") ?? "";
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState({ type: "CourseNFees" });

  const getDataList = async () => {
    setLoading(true);
    let addUrl = `id=${id}`;
    Object.keys(filters).forEach((key) => {
      const value = filters[key];
      if (value) {
        addUrl += `&${key}=${encodeURIComponent(value)}`;
      }
    });
    try {
      const response = await studentDetails(addUrl);
      if (response.data.status) {
        setData(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDataList();
  }, [filters]);

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <Master />
                  <div className="col-12">
                    <div className="row">
                      <div className="col-xl-4 col-lg-5 col-md-5 order-1 order-md-0">
                        <div className="card mb-6">
                          <div className="card-body pt-12">
                            <div className="user-avatar-section">
                              <div className="d-flex align-items-center flex-column">
                                <div className="d-flex justify-content-center mb-4">
                                  {data?.profile_picture ? (
                                    <img
                                      src={imgBaseUrl + data.profile_picture}
                                      alt=""
                                      onError={() =>
                                        setData({
                                          ...data,
                                          profile_picture: false,
                                        })
                                      }
                                      style={{
                                        width: "150px",
                                        height: "150px",
                                        objectFit: "cover",
                                        borderRadius: "50%",
                                      }}
                                    />
                                  ) : (
                                    <div
                                      className="rounded-circle border border-1 border-primary d-flex align-items-center justify-content-center bg-label-primary"
                                      style={{
                                        width: "150px",
                                        height: "150px",
                                        color: "white",
                                        fontSize: "50px",
                                        fontWeight: "600",
                                        textTransform: "uppercase",
                                      }}
                                    >
                                      {data?.name && data.name.charAt(0)}
                                    </div>
                                  )}
                                </div>
                                <div className="user-info text-center">
                                  <h5>
                                    {data?.name} ({data?.registration_no})
                                  </h5>
                                </div>
                              </div>
                            </div>
                            <div className="d-flex justify-content-between border-bottom my-2"></div>
                            <div className="info-container">
                              <ul className="list-unstyled mb-6">
                                <li className="mb-2">
                                  <span className="h6">Father's Name: </span>
                                  <span>{data?.father_name}</span>
                                </li>
                                <li className="mb-2">
                                  <span className="h6">Mother's Name: </span>
                                  <span>{data?.mother_name}</span>
                                </li>
                                <li className="mb-2">
                                  <span className="h6">Email: </span>
                                  <span> {data?.email}</span>
                                </li>
                                <li className="mb-2">
                                  <span className="h6">Mobile: </span>
                                  <span>
                                    {data?.phone}, {data?.secondary_mobile}
                                  </span>
                                </li>
                                <li className="mb-2">
                                  <span className="h6">Category: </span>
                                  <span>{data?.category}</span>
                                </li>
                                <li className="mb-2">
                                  <span className="h6">Gender: </span>
                                  <span>{data?.gender}</span>
                                </li>
                                <li className="mb-2">
                                  <span className="h6">DOB: </span>
                                  <span>{formatToDate(data?.dob)}</span>
                                </li>
                                <li className="mb-2">
                                  <span className="h6">Address: </span>
                                  <span>
                                    {data?.village} {data?.district}{" "}
                                    {data?.state} - {data?.zipcode}
                                  </span>
                                </li>

                                <li className="mb-2">
                                  <span className="h6">Admission Date: </span>
                                  <span>
                                    {formatToDate(data?.admission_date)}
                                  </span>
                                </li>
                                <li className="mb-2">
                                  <span className="h6">Aadhar: </span>
                                  <span>{data?.aadhar}</span>
                                </li>
                              </ul>
                              <div className="d-flex justify-content-center gap-2">
                                {hasAccess("/student/update") && (
                                  <Link to={`/student/update?id=${data?.id}`}>
                                    <button className="btn btn-outline-info">
                                      <i className="bi bi-pencil-square me-1"></i>{" "}
                                      Edit Profile
                                    </button>
                                  </Link>
                                )}
                                {hasAccess("/student/batch/enroll") && (
                                  <Link
                                    to={`/student/batch/enroll?student_id=${data?.id}`}
                                    className="btn btn-outline-primary "
                                  >
                                    Add In Batch
                                  </Link>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-xl-8 col-lg-7 col-md-7 order-0 order-md-1">
                        <div className="d-flex align-items-center gap-2 flex-wrap mb-3">
                          {[
                            {
                              icon: "ri-book-line",
                              type: "Course Details",
                              link: `CourseNFees`,
                            },
                            {
                              icon: "ri-pie-chart-line",
                              type: "Mark Report",
                              link: `MarkReport`,
                            },
                            {
                              icon: "ri-calendar-check-line",
                              type: "Attendance",
                              link: `Attendance`,
                            },
                            {
                              icon: "ri-hand-coin-line",
                              type: "Fee Transactions",
                              link: `Transactions`,
                            },
                            {
                              icon: "ri-government-line",
                              type: "Admission From",
                              link: `AdmissionFrom`,
                            },
                            {
                              icon: "ri-graduation-cap-line",
                              type: "Demo From",
                              link: `DemoFrom`,
                            },
                          ]?.map((type, i) => (
                            <button
                              key={i}
                              className={`btn ${
                                filters?.type === type?.link
                                  ? "btn-primary"
                                  : "btn-outline-primary btn-sm"
                              }`}
                              onClick={() =>
                                setFilters({
                                  ...filters,
                                  type: type?.link,
                                })
                              }
                            >
                              <i className={`me-2 ri-20px ${type?.icon}`}></i>{" "}
                              {type?.type}
                            </button>
                          ))}

                          {[
                            {
                              icon: "ri-hotel-bed-line",
                              type: "Hostel Portal",
                              link: `/hostel/profile?id=${data?.hostel_student?.id}`,
                              permission:
                                hasAccess("/hostel/profile") &&
                                data?.hostel_student?.id,
                            },
                            {
                              icon: "ri-graduation-cap-line",
                              type: "Library Portal",
                              link: `/library/student/profile?id=${data?.library_student?.id}`,
                              permission:
                                hasAccess("/library/student/profile") &&
                                data?.library_student?.id,
                            },
                          ]?.map((type, i) => {
                            if (!type?.permission) return null;
                            return (
                              <Link
                                key={i}
                                to={type?.link}
                                className="btn btn-outline-primary btn-sm"
                              >
                                <i className={`me-2 ri-20px ${type?.icon}`}></i>{" "}
                                {type?.type}
                              </Link>
                            );
                          })}
                        </div>

                        {filters?.type === "CourseNFees" ? (
                          <CourseNFees
                            data={data}
                            handleFunction={getDataList}
                          />
                        ) : filters?.type === "MarkReport" ? (
                          <MarkReports data={data} />
                        ) : filters?.type === "Transactions" ? (
                          <FeeTransactions
                            data={data}
                            setLoading={setLoading}
                            handleFunction={getDataList}
                          />
                        ) : filters?.type === "Attendance" ? (
                          <AttendanceCalendar
                            attendances={data?.attendances}
                            setFilters={setFilters}
                          />
                        ) : filters?.type === "Attendance" ? (
                          <MarkReports data={data} />
                        ) : filters?.type === "AdmissionFrom" ? (
                          <StudentAdmissionForm data={data} />
                        ) : filters?.type === "DemoFrom" ? (
                          <StudentDemoForm data={data} />
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
